import { StorageKey } from "core/appSettings";
import { createStore } from "core/store";

export interface SystemNotificationState {
  /** If display system-level notifications */
  showSystemNotifications: boolean;
  /** Vertical offset */
  verticalOffset: number;
}

export type SystemNotificationFunctions = {
  /**
   * Gets the current System Notification state
   * @returns The current System Notification state
   */
  getSystemNotificationState: () => SystemNotificationState;

  /**
   * Sets the System Notification state
   * @param SystemNotificationState the new System Notification state
   */
  setSystemNotificationState: (
    SystemNotificationState: SystemNotificationState
  ) => void;
};

const initialState = {
  showSystemNotifications: false,
  verticalOffset: 0,
} as SystemNotificationState;

/**
 * Registers the System Notification in sessionStorage
 * @param systemNotificationState The new state of the System Notification
 */
export function useRegisterSystemNotification(): SystemNotificationFunctions {
  const { state, updateState } = useSystemNotificationStore();

  const getSystemNotificationState = (): SystemNotificationState => {
    return state;
  };

  const setSystemNotificationState = (
    SystemNotificationState: SystemNotificationState
  ): void => {
    updateState(SystemNotificationState);
  };

  return { getSystemNotificationState, setSystemNotificationState };
}

const useSystemNotificationStore = createStore<SystemNotificationState>({
  name: StorageKey.SYSTEM_NOTIFICATION,
  storage: sessionStorage,
  initialState,
});
